package com.klantenstop.web.pages.authentication.forgotPassword

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.navigation.unauthenticatedGuard
import com.klantenstop.web.pages.authentication.components.AuthenticationContainer
import com.klantenstop.web.pages.authentication.registration.authLinkModifier
import com.materialkobweb.styles.MaterialColorVars
import com.klantenstop.web.utils.Res
import com.klantenstop.web.utils.format
import com.materialkobweb.utils.rememberViewModel
import com.klantenstop.web.utils.withAlpha
import com.materialkobweb.components.DsPageLayout
import com.materialkobweb.components.widgets.DsEditableField
import com.materialkobweb.components.widgets.FilledButton
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Page("/wachtwoord-vergeten")
@Composable
fun ForgotPasswordPage() = unauthenticatedGuard {
    val pageContext = rememberPageContext()
    val email = remember { pageContext.route.params["email"] ?: "" }

    // Use constant key to maintain ViewModel across navigation
    val viewModel = rememberViewModel(cached = false) { ForgotPasswordViewModel(email) }
    val state by viewModel.state.collectAsState()

    ForgotPasswordPageContent(
        state = state,
        sendIntent = viewModel::sendIntent
    )
}

@Composable
private fun ForgotPasswordPageContent(
    state: ForgotPasswordContract.State,
    sendIntent: (ForgotPasswordContract.Intent) -> Unit
) {
    DsPageLayout(
        modifier = Modifier.fillMaxSize(),
        title = Res.String.DocumentTitle.format("Wachtwoord vergeten"),
        header = {},
        footer = {}
    ) {
        AuthenticationContainer(
            title = "Wachtwoord vergeten?",
            content = {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(16.px, Alignment.CenterVertically)
                ) {
                    SpanText(
                        text = "Vul je e-mailadres in en we sturen je instructies om je wachtwoord te resetten.",
                        modifier = Modifier
                            .fillMaxWidth()
                            .fontSize(14.px)
                            .lineHeight(20.px)
                            .color(MaterialColorVars.OnSurfaceVariant.value())
                            .margin(bottom = 8.px)
                    )

                    DsEditableField(
                        modifier = Modifier.fillMaxWidth(),
                        id = "forgot-password-email",
                        label = "E-mailadres",
                        placeholder = "E-mailadres",
                        value = state.emailAddress,
                        valid = !state.showValidation || state.emailAddress.isNotEmpty(),
                        onValueChange = { sendIntent(ForgotPasswordContract.Intent.UpdateEmail(it)) },
                        required = true,
                        backgroundColor = MaterialColorVars.SurfaceContainer.value(),
                        focusBorderColor = MaterialColorVars.Primary.withAlpha(0.6f)
                    ) { sendIntent(ForgotPasswordContract.Intent.SubmitForgotPassword) }
                }

                FilledButton(
                    modifier = Modifier.fillMaxWidth(),
                    type = ButtonType.Submit,
                    onClick = { sendIntent(ForgotPasswordContract.Intent.SubmitForgotPassword) },
                    enabled = !state.isLoading
                ) {
                    Text(if (state.isLoading) "Bezig..." else "Verstuur reset link")
                }
            },
            footer = {
                Text("Weet je je wachtwoord weer? ")
                Link(
                    modifier = authLinkModifier,
                    path = Navigation.Screen.Login().route,
                    updateHistoryMode = UpdateHistoryMode.REPLACE,
                    text = "Log in"
                )
            }
        )
    }
}
